export const checklistOptions = [
  {
    label: "Kerrotko koko nimesi?",
    englishLabel: "Can you tell me your full name?",
    value: "full-name"
  },
  {
    label: "Henkilötunnus?",
    englishLabel: "Your personal identity number",
    value: "personal-number"
  },
  { label: "Sähköpostiosoite?", englishLabel: "Email address", value: "email" },
  { label: "Puhelinnumero?", englishLabel: "Phone number", value: "phone" },
  {
    label: "Nykyinen kotiosoite? (Vanha kotiosoite?)",
    englishLabel: "Your home address (Your previous home address)",
    value: "address"
  },
  {
    label: "Lainasumma on ___ ja laina-aika on ___",
    englishLabel: "The loan amount is ___ and the loan period is ___",
    value: "loan-amount-and-period"
  },
  {
    label: "Laskujen eräpäivä on ___",
    englishLabel: "The due date of the bills is ___",
    value: "due-date"
  },
  {
    label: "Tilinumerosi IBAN muodossa?",
    englishLabel: "Your account number, full IBAN",
    value: "account-number"
  },
  {
    label: "Nimelliskorko on ___ Tod. vuosikorko on ___",
    englishLabel:
      "The nominal interest rate is ___ The effective annual interest rate is ___",
    value: "interest-rate"
  },
  {
    label: "Maksuerän suuruus on ___",
    englishLabel: "The amount of the payment is ___",
    value: "payment-amount"
  }
];

export const insuranceChecklistOptions = [
  {
    label: "Oletko vakituisessa työsuhteessa vähintään 50 % (17 h/vko)?",
    englishLabel:
      "Are you in a permanent employment at least 50% (17 hours/week)?",
    value: "permanent-employment"
  },
  {
    label:
      "Asutko pysyvästi Suomessa ja kuulut Suomen sosiaaliturvan piiriin (Sinulla on Kela-kortti)?",
    englishLabel:
      "Do you live permanently in Finland and are you covered by Finnish social security (Do you have a Kela card)?",
    value: "finnish-social-security"
  },
  {
    label: "Oletko tällä hetkellä terve ja hyvässä kunnossa?",
    englishLabel: "Are you healthy and in good shape?",
    value: "health"
  },
  {
    label:
      "Onko sinulla tietoa mahdollisesta irtisanomisesta, työkyvyttömyydestä, sairaslomasta tai sairaalassa olo ajasta?",
    englishLabel:
      "Do you have any information about possible unemployment, lay off, sick leave, or time spent in the hospital?",
    value: "termination"
  }
];
